import React from "react";
import Modal from "components/common/Modal";

const NotFoundModal = ({ show, onClose }) => {
  return (
    <Modal show={show} title="Protocolo não encontrado" onClose={onClose}>
      Confira se você digitou os números corretamente ou se escolheu o produto correto e tente novamente.
      <br />
      <br />
      Se você ainda não possui uma reclamação registrada fale com a gente no
      canal de atendimento específico da empresa do seu produto.
      <br />
      <br />
      <strong>Caixa Seguradora</strong>
      <br />
      Central de atendimento:{" "}
      <a href="tel:08002741000">
        <strong>0800 274 1000</strong>
      </a>
      <br />
      Canal de atendimento ao surdo (CAS):{" "}
      <a href="tel: 08007024260">
        <strong>0800 702 4260</strong>
      </a>
      <br />
      <br />
      <strong>Youse</strong>
      <br />
      SAC:{" "}
      <a href="tel: 08007309903">
        <strong>0800 730 9903</strong>
      </a>
      <br />
      Canal para pessoa com deficiência auditiva:{" "}
      <a href="tel: 08007309904">
        <strong>0800 730 9904</strong>
      </a>
    </Modal>
  );
};

export default NotFoundModal;
